import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 17px;
  border-radius: 8px;
  width: 100%;

  hr {
    width: 100%;
    color: transparent;
    border: none;
    border-top: 1px dashed ${(props) => props.theme.hrColor};
    margin: 1rem auto;
  }

  .stats-title {
    font-size: 1.3rem;
  }
`;

export const CompetitionNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0;
`;

export const CompetitionName = styled.p`
  color: ${(props) => props.theme.black};
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const TeamsRow = styled.div<{ addMarginBottom?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.addMarginBottom ? "0.6rem" : "0")};
  p {
    margin: 0;
    color: ${(props) => props.theme.black};
    font-size: 1.3rem;
    font-weight: bold;
  }
`;

export const TeamDivider = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  color: ${(props) => props.theme.sepColor};
  font-size: 0.75rem;
  hr {
    width: 100%;
    color: transparent;
    border: none;
    border-top: 0.5px solid ${(props) => props.theme.sepColor};
    margin: 0.6rem auto;
  }
`;

export const TeamContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  img {
    height: 24px;
    width: 24px;
    object-fit: cover;
  }
  @media (max-width: 425px) {
    gap: 5px;
  }
`;

export const TeamSeparator = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-left: 6px;
`;

export const RightContainer = styled.div<{ grey?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    color: ${(props) => props.theme.black};
  }
`;

export const FixturePanel = styled.div`
  margin: 10px 0;
  font-size: 13px;
`;

export const Team = styled.span<{ selected?: boolean }>`
  font-weight: ${(props) => (props.selected ? "bold" : "noraml")};
`;

export const ChartPanel = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  span {
    font-weight: bold;
    margin-right: 12px;
    color: ${(props) => props.theme.probabilityHighlight};
  }
`;

export const ChartIcon = styled.div`
  img {
    height: 26px;
    width: 26px;
  }
`;
